<script>
export default {
  data() {
    return {
      loaded: false
    }
  },
  props: {
    id: {
      type: String,
      required: true
    },
    size: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: true
    },
    method: {
      type: String,
      default: 'GET'
    }
  },
  methods: {
    open() {
      this.refresh();
      let modal = bootstrap.Modal.getOrCreateInstance(this.$el);
      modal.show();
    },

    close() {
      let modal = bootstrap.Modal.getOrCreateInstance(this.$el);
      modal.hide();
    },

    refresh() {
      $.ajax({
        url: this.url,
        method: this.method,
        success: (response) => {
          $(this.$el).find('[data-content]').html(response.html);
        }
      }).always(() => {
        this.loaded = true;
      });
    }
  },
}
</script>

<template>
  <div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
    <div :class="{'modal-dialog modal-dialog-centered': true, [`modal-${this.size}`]: size}">
      <div class="modal-content" data-content></div>
    </div>
  </div>
</template>